import { SuspensionType } from "src/app/core/interfaces/suspension-type.interface";
import { AdminPagesStateModel } from "../../admin.state";

export class SuspensionTypesStateModel extends AdminPagesStateModel {
  items: SuspensionType[];
}